import React from 'react';
import { motion } from 'framer-motion';
type MenuItem = {
  name: string;
  description?: string;
  price?: string;
};
type MenuSection = {
  category: string;
  note?: string;
  items: MenuItem[];
  footer?: string;
};
const menuData: MenuSection[] = [{
  category: 'Starters',
  items: [{
    name: 'Rockefeller Oysters',
    description: 'Spinach & artichoke, Parmigiano-Reggiano, Burrata cheese',
    price: '29'
  }, {
    name: 'Josephine Thai Coconut Mussels',
    description: 'Wok steamed mussels in a Thai coconut milk broth topped with basil',
    price: '27'
  }, {
    name: 'Firecracker Shrimp',
    description: 'Hand breaded shrimp tossed in our homemade firecracker sauce',
    price: '27'
  }, {
    name: 'Caribbean Fried Egg Rolls',
    description: 'Chicken, black beans, and corn served with Thai sweet chili sauce and Cajun ranch',
    price: '28'
  }, {
    name: 'Salt & Five Spices Calamari or Tiger Shrimp',
    description: 'Breaded with cornstarch, eggs, sautéed with scallions, and dried red peppers',
    price: '28'
  }, {
    name: 'Spinach & Artichoke Dip',
    description: 'With Naan bread',
    price: '19'
  }, {
    name: 'Malaysian Flat Bread',
    description: 'Soft and buttery flaky flat bread, toasted, served with homemade Malaysian curry',
    price: '27'
  }, {
    name: 'Crispy Parmesan Truffle Fries',
    description: 'Fried and toasted with black truffle oil and sprinkled with fresh and grated Parmesan cheese',
    price: '15'
  }]
}, {
  category: 'Soup & Salads',
  items: [{
    name: 'Freddie',
    description: 'Spring mixed greens with grape tomatoes, bourbon bacon, bleu cheese crumbs, roasted candy pecans topped with buttermilk ranch dressing • Add chicken or shrimp – 22',
    price: '12'
  }, {
    name: 'Sesame Ginger Salad',
    description: 'Mixed greens, carrots, cucumbers, tomatoes, scallions, sesame seeds & homemade ginger dressing • Add Ahi Tuna – 28',
    price: '10'
  }, {
    name: 'Chargrilled Caesar',
    description: 'Grilled romaine lettuce, Caesar dressing served with a crostini • Add grilled chicken – 22',
    price: '10'
  }, {
    name: '211 Wedge',
    description: 'Iceberg lettuce, tomatoes, egg, carrots, cucumber, bacon and blue cheese crumbles, drizzled with bleu cheese or Cajun ranch',
    price: '10'
  }, {
    name: 'Lobster Bisque',
    price: '16'
  }, {
    name: 'Coconut Shrimp Soup',
    description: 'Chile, crème, lime, cilantro',
    price: '16'
  }]
}, {
  category: 'Fresh Homemade Pasta',
  note: 'Vodka Rosé, Pasta Carbonara & Louisiana Cajun Olive Oil — choose your protein: Grilled Chicken 28 · Prime Beef Tips 36 · Tiger Shrimp 36 · Lobster 48',
  items: [{
    name: 'Steak Gorgonzola',
    description: 'Gorgonzola cream sauce with Mafalda pasta, red onions, mushrooms, and spinach topped with prime beef tips and a balsamic reduction',
    price: '35'
  }, {
    name: 'Vodka Rosé',
    description: 'Sautéed with red onions, baby bella mushrooms, and tomatoes with Gnocchetti Sardi pasta'
  }, {
    name: 'Pasta Carbonara',
    description: 'Bucatini pasta with alfredo sauce, diced pork belly, mushroom, cherry tomatoes, and spinach'
  }, {
    name: 'Louisiana Cajun Olive Oil',
    description: 'Sautéed red onion, baby bella mushrooms and cherry tomatoes with Bucatini pasta'
  }, {
    name: 'Chicken Pesto',
    description: 'Alfredo, tomato, pesto, parmesan, Mafalda pasta',
    price: '30'
  }, {
    name: 'Mussels and Clams',
    description: 'White wine, shallot, capers, lemon, Bucatini pasta',
    price: '38'
  }, {
    name: 'Pasta Primavera',
    description: 'Red onion, asparagus, tomato, spinach, mushroom, green pea, white wine sauce, Gnocchetti Sardi pasta',
    price: '28'
  }]
}, {
  category: 'Lovers of the Sea',
  note: 'Served with one side of your choice',
  items: [{
    name: 'Chargrilled Salmon',
    description: 'Piccata Scottish salmon, chargrilled with a lemon butter capers white wine sauce',
    price: '48'
  }, {
    name: 'Chilean Sea Bass',
    description: 'Grilled garlic ginger spinach on sea bass, topped with Jumbo Tiger Shrimp',
    price: '62'
  }, {
    name: 'Lobster Fromage with Tiger Shrimp',
    description: 'Lobster sauce topped with Colby jack cheese served with Cajun alfredo Gnocchetti Sardi pasta, tomatoes, and spinach',
    price: '60'
  }, {
    name: 'Risotto with Tiger Shrimp',
    description: 'Buttery saffron risotto with Japanese shitake, topped with Tiger Shrimp',
    price: '38'
  }]
}, {
  category: 'The Land Connoisseur',
  note: 'Served with your choice of side',
  items: [{
    name: 'Hickory Smoked Pork Loin',
    description: 'Rubbed with herb salt and slow smoked and grilled served with bacon bourbon jam',
    price: '32'
  }, {
    name: 'Marsala Chicken',
    description: 'Creamy rich saffron Marsala sauce with baby bella mushroom atop our grilled marinated chicken',
    price: '36'
  }, {
    name: 'Bone-In Pork Chop',
    description: '2 inch, brined, sous vide, chargrilled with peaches, pears, and bourbon bacon plum jam',
    price: '48'
  }, {
    name: 'Lamb Chops',
    description: 'Chargrilled to your perfection',
    price: '65'
  }, {
    name: 'Barrel Cut Filet',
    description: '8 oz. Australia, 6 months dry-aged, sous vide, chargrilled and Pittsburgh topped with horseradish crème, Dijon, shallot, dill',
    price: '72'
  }, {
    name: 'Surf and Turf',
    description: 'Beef tenderloin, sous vide, chargrilled with your choice of Tiger Shrimp – 79 or Lobster Tail – 89'
  }, {
    name: 'Smoked 20 oz. Australia Ribeye',
    description: 'Grilled and Pittsburgh to your perfection',
    price: '70'
  }, {
    name: 'Hickory Smoked Pork Shank',
    description: 'Braised to perfection, served with housemade mashed potatoes',
    price: '57'
  }, {
    name: 'Aged Ribeye and Brisket Cheeseburger',
    description: '8 oz. ground ribeye and brisket grilled to perfection, topped with Colby Jack and Mozzarella cheese on brioche bun, served with lettuce, tomatoes, banana peppers, sliced pickles and Yukon fries',
    price: '34'
  }]
}, {
  category: 'Sides',
  items: [{
    name: 'Classic Sides',
    description: 'Asparagus · Fried Brussels · Cajun Cream Corn · Broccolini'
  }, {
    name: 'Shitake Mushroom Risotto',
    price: '12'
  }, {
    name: 'Fried Redskin Potatoes',
    description: 'Topped with Colby Jack and Mozzarella cheese',
    price: '15'
  }, {
    name: 'Malfalda Alfredo',
    price: '12'
  }, {
    name: 'Cajun Mac & Cheese',
    price: '10'
  }, {
    name: 'Burgundy Mushroom',
    description: 'With butter, shallot, thyme',
    price: '12'
  }],
  footer: 'Entrée Split Charge – 6 · Salad Split Charge – 3 · Dessert Plate Charge – 2 · Extra Bread – 4'
}];
export function MenuHighlights() {
  return <section id="menu" className="py-32 px-6 bg-brand-charcoal relative border-y border-brand-gold/10" data-id="element-93">
      <div className="max-w-5xl mx-auto" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-95">
          <h2 className="font-serif text-4xl md:text-5xl text-brand-offwhite mb-6" data-id="element-96">
            Our Menu
          </h2>
          <div className="w-12 h-px bg-brand-gold mx-auto" data-id="element-97"></div>
        </motion.div>

        <div className="space-y-24" data-id="element-98">
          {menuData.map((section, sectionIdx) => <motion.div key={section.category} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7
        }} data-id="element-99">
              <div className="text-center mb-10" data-id="element-100">
                <h3 className="font-serif text-3xl text-brand-gold uppercase tracking-widest mb-3" data-id="element-101">
                  {section.category}
                </h3>
                {section.note && <p className="text-sm text-brand-offwhite/50 italic max-w-2xl mx-auto" data-id="element-102">
                    {section.note}
                  </p>}
              </div>

              <div className="space-y-7 max-w-3xl mx-auto" data-id="element-103">
                {section.items.map((item, itemIdx) => <div key={itemIdx} className="flex flex-col" data-id="element-104">
                    <div className="flex justify-between items-baseline gap-2" data-id="element-105">
                      <h4 className="font-serif text-lg text-brand-offwhite tracking-wide flex-shrink-0" data-id="element-106">
                        {item.name}
                      </h4>
                      {item.price && <>
                          <div className="flex-grow border-b border-dotted border-brand-gold/30 relative top-[-4px]" data-id="element-107"></div>
                          <span className="text-brand-gold font-serif text-lg flex-shrink-0" data-id="element-108">
                            {item.price}
                          </span>
                        </>}
                    </div>
                    {item.description && <p className="text-sm text-brand-offwhite/50 italic mt-1 leading-relaxed" data-id="element-109">
                        {item.description}
                      </p>}
                  </div>)}
              </div>

              {section.footer && <p className="text-center text-sm text-brand-offwhite/40 italic mt-10" data-id="element-110">
                  {section.footer}
                </p>}
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-24 text-center border-t border-brand-gold/10 pt-12" data-id="element-111">
          <p className="text-sm text-brand-offwhite/50 italic mb-2" data-id="element-112">
            20% gratuity added to parties of 8 or more. 3% added to credit card
            sales only.
          </p>
          <p className="text-sm text-brand-offwhite/50 italic" data-id="element-113">
            Please let your server know of peanut or any other allergies.
          </p>
        </motion.div>
      </div>
    </section>;
}